if (!customElements.get('noor-shop-experience')) {
  customElements.define('noor-shop-experience', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const purchase = event.target.closest('[data-purchase]');
        if (purchase) {
          event.preventDefault();
          this.addToCart(purchase);
          return;
        }
        const design = event.target.closest('[data-design]');
        if (design) this.choose(design.dataset.design);
        const view = event.target.closest('[data-view-src]');
        if (view) {
          const panel = view.closest('[data-design-media]');
          const main = panel.querySelector('[data-main-image]');
          main.src = view.dataset.viewSrc;
          main.alt = view.dataset.viewAlt;
          panel.querySelector('.ncshop-image-label').textContent = view.dataset.viewLabel;
          panel.querySelectorAll('[data-view-src]').forEach(button => button.setAttribute('aria-pressed', String(button === view)));
        }
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-variant]')) return;
        const option = event.target.selectedOptions[0];
        const panel = event.target.closest('[data-design-info]');
        panel.querySelector('[data-price]').textContent = option.dataset.price;
        panel.querySelector('[data-original-price]').textContent = option.dataset.originalPrice;
        panel.querySelector('.ncshop-original').hidden = option.dataset.onSale !== 'true';
        const link = panel.querySelector('[data-purchase]');
        link.dataset.variantId = option.value;
        link.disabled = option.dataset.available !== 'true';
        panel.querySelector('[data-stock]').hidden = option.dataset.available === 'true';
      });
      this.addEventListener('keydown', event => {
        const button = event.target.closest('[data-design]');
        if (!button || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const buttons = Array.from(this.querySelectorAll('[data-design]'));
        let index = buttons.indexOf(button);
        const rtl = getComputedStyle(this).direction === 'rtl';
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = buttons.length - 1;
        else index = (index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1) + buttons.length) % buttons.length;
        buttons[index].focus(); this.choose(buttons[index].dataset.design);
      });
    }
    choose(design) {
      const source = this.querySelector('[data-design-media="' + design + '"] [data-view-src]');
      const name = this.querySelector('[data-design-info="' + design + '"] .ncshop-design-name');
      this.querySelectorAll('[data-size-image]').forEach(image => {
        image.src = source.dataset.viewSrc;
        image.alt = image.dataset.sizeLabel + ' — ' + name.textContent;
      });
      this.querySelectorAll('[data-design]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.design === design)));
      this.querySelectorAll('[data-design-media]').forEach(panel => panel.hidden = panel.dataset.designMedia !== design);
      this.querySelectorAll('[data-design-info]').forEach(panel => panel.hidden = panel.dataset.designInfo !== design);
    }
    async addToCart(button) {
      if (button.disabled || button.dataset.adding === 'true') return;
      const variantId = button.dataset.variantId;
      const label = button.querySelector('[data-purchase-label]');
      const originalLabel = label?.textContent || '';
      button.dataset.adding = 'true';
      button.disabled = true;
      if (label) label.textContent = 'Adding…';
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add to cart');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { sections: {} } } }));
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        if (label) label.textContent = 'Added';
        setTimeout(() => { if (label) label.textContent = originalLabel; }, 1400);
      } catch (error) {
        console.error(error);
        if (label) label.textContent = 'Add to cart';
      } finally {
        button.dataset.adding = 'false';
        button.disabled = false;
      }
    }
  });
}
